import * as React from 'react'

function SvgLicense(props, svgRef) {
  return (
    <svg viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path d="M8.516 4.016h2.637a.44.44 0 00.31-.75L8.828.628a.44.44 0 00-.75.31v2.637c0 .243.197.44.44.44z" />
      <path d="M8.516 4.895a1.32 1.32 0 01-1.318-1.319V.5H.606a.44.44 0 00-.44.44v14.12c0 .243.197.44.44.44h10.547a.44.44 0 00.44-.44V4.896H8.515zM3.038 3.723h.44v-.44a.44.44 0 11.878 0v.44h.44a.44.44 0 110 .879h-.44v.439a.44.44 0 11-.879 0v-.44h-.44a.44.44 0 110-.878zm2.256 9.404h-2.93a.44.44 0 010-.879h2.93a.44.44 0 110 .879zm0-1.748h-2.93a.44.44 0 110-.879h2.93a.44.44 0 110 .879zm0-1.748h-2.93a.44.44 0 110-.88h2.93a.44.44 0 110 .88zm0-1.777h-2.93a.44.44 0 110-.88h2.93a.44.44 0 110 .88zm4.101 5.273H7.637a.44.44 0 010-.879h1.758a.44.44 0 110 .879zm0-1.758H7.637a.44.44 0 110-.879h1.758a.44.44 0 010 .88zm0-1.758H7.637a.44.44 0 110-.879h1.758a.44.44 0 110 .88z" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgLicense)
export default ForwardRef
